var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.scores), function(score, index) {
    return (index == (_vm.$route.params.index - 1)) ? _c('div', {
      staticClass: "viewer-container"
    }, [(score.manifest) ? _c('viewer', {
      staticClass: "viewer-outlet",
      attrs: {
        "manifest": score.manifest
      }
    }) : (score.url) ? _c('iframe', {
      attrs: {
        "src": score.url,
        "frameborder": "0"
      }
    }) : _c('h2', {
      staticClass: "viewer__empty"
    }, [_vm._v("Viewer for " + _vm._s(score.title) + " TK")])], 1) : _vm._e()
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e306f382","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewWrapper.vue
// module id = E+Nl
// module chunks = 0